import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LabelDisplayItemComponent, LabelRepository } from '@lib/label';
import { CommonModule as ProgetSharedCommonModule } from '@proget-shared/_common';
import { ConfigurableDialog, DialogModule, DialogService } from '@proget-shared/dialog';
import { PickListModule } from '@proget-shared/form/pick-list';
import { TranslateModule } from '@proget-shared/translate';
import { SpinnerModule } from '@proget-shared/ui/spinner';
import { ToastService } from '@proget-shared/ui/toast';

import { User } from '../../model';
import { UserCardRepository } from '../../user-card.repository';

@Component({
  selector: 'lib-manage-labels',
  templateUrl: './manage-labels.component.html',
  styleUrl: './manage-labels.component.scss',
  imports: [
    ReactiveFormsModule,
    DialogModule,
    SpinnerModule,
    PickListModule,
    ProgetSharedCommonModule,
    LabelDisplayItemComponent,
    TranslateModule,
  ],
})
export class ManageLabelsComponent implements OnInit, ConfigurableDialog {
  protected readonly form: FormGroup;

  protected options = [];
  protected loading = false;

  private readonly dialogService = inject(DialogService);
  private readonly toastService = inject(ToastService);
  private readonly labelRepository = inject(LabelRepository);
  private readonly userCardRepository = inject(UserCardRepository);

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group({
      id: [null, [Validators.required]],
      labels: [[]],
    });
  }

  ngOnInit(): void {
    this.loadLabels();
  }

  onConfiguration({ user }: { user: User }): void {
    this.form.patchValue({
      id: user.uuid,
      labels: user.labels.map((label) => label.id),
    });
  }

  protected close(): void {
    this.dialogService.close(this);
  }

  protected submit(): void {
    this.loading = true;

    this.userCardRepository.setLabels(this.form.value.id, this.form.value.labels)
      .subscribe({
        next: () => {
          this.toastService.success('library.user_card.toast.manage_labels.success');
          this.dialogService.resolve(this);
          this.loading = false;
        },
        error: () => {
          this.toastService.error('library.user_card.toast.manage_labels.error');
          this.loading = false;
        },
      });
  }

  private loadLabels(): void {
    this.loading = true;

    this.labelRepository.getLabelsOptions()
      .subscribe({
        next: (labels) => {
          this.options = labels;
          this.loading = false;
        },
        error: () => {
          this.options = [];
          this.loading = false;
        },
      });
  }
}
